import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, User } from 'lucide-react';
import AdminLayout from './AdminLayout';
import { api } from '../../lib/api';
import { fmtDate } from '../../lib/format';

export default function AdminClientsPage() {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const t = setTimeout(() => { api.adminClients(search || undefined).then(setList); }, 250);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <AdminLayout title="Clients" subtitle={`${list.length} client${list.length === 1 ? '' : 's'}`}>
      <div className="rounded-xl bg-white border border-neutral-100">
        <div className="p-4 border-b border-neutral-100">
          <div className="relative max-w-md">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search clients" className="w-full pl-9 pr-3 py-2.5 rounded-md border border-neutral-200 text-[13.5px] focus:border-[#f5b300] outline-none" />
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-[13.5px]">
            <thead className="text-[11px] uppercase tracking-wider text-neutral-400 bg-[#faf6ec]">
              <tr>
                <th className="px-5 py-3 text-left">Name</th>
                <th className="px-5 py-3 text-left">Email</th>
                <th className="px-5 py-3 text-left">Phone</th>
                <th className="px-5 py-3 text-left">Company</th>
                <th className="px-5 py-3 text-right">Last update</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 && (<tr><td colSpan={5} className="py-10 text-center text-neutral-400 text-[13px]">No clients yet.</td></tr>)}
              {list.map((c) => (
                <tr key={c.id} className="border-t border-neutral-100 hover:bg-[#faf6ec]/60">
                  <td className="px-5 py-3">
                    <Link to={`/admin/clients/${c.id}`} className="flex items-center gap-3 hover:text-[#c89200]">
                      <div className="w-8 h-8 rounded-full bg-[#f5b300]/15 flex items-center justify-center text-[#c89200] font-bold text-[12px]">{c.first_name?.[0] || 'C'}</div>
                      <span className="font-medium text-[#14110f]">{c.first_name} {c.last_name}</span>
                    </Link>
                  </td>
                  <td className="px-5 py-3 text-neutral-600">{c.email}</td>
                  <td className="px-5 py-3 text-neutral-500">{c.phone || '—'}</td>
                  <td className="px-5 py-3 text-neutral-500">{c.company || '—'}</td>
                  <td className="px-5 py-3 text-right text-neutral-400 text-[12.5px]">{fmtDate(c.updated_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
